const UNBRANDED_BUTTON_SELECTOR = '.shopify-payment-button__button--unbranded';
const watchedPaymentButtons = new WeakSet();

function buyNowLabelFor(container) {
  const host = container.closest('block-buy-buttons');
  return host?.dataset?.buyNowLabel?.trim() || '';
}

function applyBuyNowLabel(container) {
  const label = buyNowLabelFor(container);
  if (!label) return;

  container.querySelectorAll(UNBRANDED_BUTTON_SELECTOR).forEach((button) => {
    if (button.textContent.trim() !== label) {
      button.textContent = label;
    }
  });
}

// Mirror add-to-cart onto "buy now": Shopify only adds the real `disabled` attribute on variant
// change, so any load that starts sold out leaves it clickable. See docs.md.
function applyBuyNowDisabledState(container) {
  const addButton = container.closest('block-buy-buttons')?.querySelector('[name="add"]');
  if (!addButton) return;

  const soldOut = addButton.hasAttribute('disabled');

  container.querySelectorAll(UNBRANDED_BUTTON_SELECTOR).forEach((button) => {
    if (soldOut) {
      button.setAttribute('disabled', 'disabled');
    } else if (button.getAttribute('aria-disabled') !== 'true') {
      // Only re-enable when Shopify agrees the variant is purchasable.
      button.removeAttribute('disabled');
    }
  });
}

function applyBuyNowState(container) {
  applyBuyNowLabel(container);
  applyBuyNowDisabledState(container);
}

function watchPaymentButton(container) {
  if (watchedPaymentButtons.has(container)) return;
  watchedPaymentButtons.add(container);
  applyBuyNowState(container);
  const observer = new MutationObserver(() => applyBuyNowState(container));
  observer.observe(container, { childList: true, subtree: true, characterData: true });

  // The container mutates when Shopify injects the button; add-to-cart mutates when the
  // shopper picks another size (assets/block-buy-buttons.js:43-61). Watch both.
  const addButton = container.closest('block-buy-buttons')?.querySelector('[name="add"]');
  if (addButton) {
    const addObserver = new MutationObserver(() => applyBuyNowDisabledState(container));
    addObserver.observe(addButton, { attributeFilter: ['disabled'] });
  }
}

function scanPaymentButtons() {
  document.querySelectorAll('block-buy-buttons[data-buy-now-label] .shopify-payment-button').forEach(watchPaymentButton);
}

function initBuyNowLabel() {
  scanPaymentButtons();
  const bootObserver = new MutationObserver(scanPaymentButtons);
  bootObserver.observe(document.documentElement, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBuyNowLabel);
} else {
  initBuyNowLabel();
}
